// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CircleLoader_wrapper__Hf9XO","loader":"CircleLoader_loader__aWC3k","rotation":"CircleLoader_rotation__x5TEp","small":"CircleLoader_small__3dBUV"};